import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)


export const constantRoutes = [{
  path: '/',
  component: () => import('../views/Main.vue'),
  redirect: '/home',
  children: [{
    path: '/home',
    component: () => import('../views/index/index'),
    hidden: false
  }]
}, {
  path: '/buyVip',
  component: () => import('../views/Main1.vue'),
  redirect: '/buyVip1',
  children: [{
    path: '/buyVip1',
    component: () => import('../views/buyVip/index'),
    hidden: false
  }]
}, {
  path: '/Main3',
  component: () => import('../views/Main3.vue'),
  redirect: '/search',
  children: [{
    path: '/search',
    component: () => import('../views/search/index'),
    hidden: false
  }]
}, {
  path: '/Main2',
  component: () => import('../views/Main2.vue'),
  redirect: '/myinfo',
  children: [{
    path: '/myinfo',
    component: () => import('../views/myinfo/index'),
    redirect: '/userinfo',
    children: [{
      path: '/userinfo',
      component: () => import('../views/myinfo/userinfo')
    }, {
      path: '/myauthentication',
      component: () => import('../views/myinfo/myauthentication')
    }, {
      path: '/wallet',
      component: () => import('../views/myinfo/wallet')
    }, {
      path: '/order',
      component: () => import('../views/myinfo/order')
    }, {
      path: '/message',
      component: () => import('../views/myinfo/message')
    }, {
      path: '/wealth',
      component: () => import('../views/myinfo/wealth')
    }, {
      path: '/uploads',
      component: () => import('../views/myinfo/uploads')
    }, {
      path: '/down',
      component: () => import('../views/myinfo/down')
    },  {
      path: '/collection',
      component: () => import('../views/myinfo/collection')
    }, {
      path: '/forward',
      component: () => import('../views/myinfo/forward')
    }, {
      path: '/agreement',
      component: () => import('../views/myinfo/agreement')
    }]
  }, {
    path: '/cominfo',
    component: () => import('../views/com/cominfo.vue'),
  }, {
    path: '/comtext',
    component: () => import('../views/com/comtext.vue'),
  }, {
    path: '/comtext',
    component: () => import('../views/com/comtext.vue'),
  }, {
    path: '/recharge',
    component: () => import('../views/com/recharge.vue'),
  }, {
    path: '/weburl',
    component: () => import('../views/com/weburl.vue'),
  }]
}]

// 动态路由，基于用户权限动态去加载


// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

export default new Router({
  // mode: 'history', // 去掉url中的#
  mode: 'hash',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js